<div *transloco="let t; prefix: 'mac-address-print-result'">
    <h1>{{ t('title') }}</h1>
    <h2>{{ t('note') }}</h2>
    <table>
        <thead>
            <tr class='table-header'>
                <th>{{ t('serialNumber') }}</th>
                <th>{{ t('macAddress') }}</th>
            </tr>    
        </thead>
        <tbody *ngIf="tableData && tableData.length > 0">
            <tr *ngFor="let data of tableData">
                <td>
                   <span [class.error]="data.error">{{data?.serialno}}</span>
                </td>
                <td *ngIf="!data.error" class='mac-address'>
                    {{data?.macaddress}}
                </td>
                <td *ngIf="data.error"  class="align-left">
                    <span class='error'>{{prepareErrorMessage(data?.error)}}</span>
                </td>
            </tr>
        </tbody>
    </table>
</div>
